module.exports = __webpack_public_path__ + "img/710.a269f2f0.jpg";